import { Modal, Button, Form } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useState } from "react";
// import LeadStageModal from "./LeadStageModal";
// import EditLeadStage from "./EditLeadStageModal";
// import DeleteLeadStageModal from "./DeleteLeadStageModal";
import EditStage from "./EditStage";
import DeleteLeadStage from "./DeleteLeadStage";
import EditLeadStage from "./EditLeadStage";



// import AddStageModal from "./AddStageModal";
// import EditContactStageModal from "./EditContactStageModal";
// import DeleteContactStageModal from "./DeleteContactStageModal";


const EditPipelineModal = ({ show, handleClose }) => {
  const [showAddStage, setShowAddStage] = useState(false);
  const [showEditStage, setShowEditStage] = useState(false);
  const [showDeleteStage, setShowDeleteStage] = useState(false);

  const stages = ["Inpipeline", "Follow Up", "Schedule Service"];

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" className="pipeline-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add New Pipeline</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {/* NAME */}
          <Form.Group>
            <Form.Label>Pipeline Name *</Form.Label>
            <Form.Control />
          </Form.Group>

          {/* STAGES */}
          <div className="mt-3">
            <div className="d-flex justify-content-between">
              <Form.Label>Pipeline Stages *</Form.Label>
              <span className="add-new" onClick={() => setShowAddStage(true)}>
                + Add New
              </span>
            </div>

            {stages.map((stage, i) => (
              <div key={i} className="stage-item">
                <span>⋮⋮ {stage}</span>

                <div className="icons">
                  <FiEdit2 onClick={() => setShowEditStage(true)} />
                  <FiTrash2 onClick={() => setShowDeleteStage(true)} />
                </div>
              </div>
            ))}
          </div>

          {/* ACCESS */}
          <div className="mt-3">
            <Form.Label>Access</Form.Label>
            <div className="d-flex gap-3 mt-1">
              <Form.Check label="All" type="radio" name="access" defaultChecked />
              <Form.Check label="Select Person" type="radio" name="access" />
            </div>
          </div>

          {/* FOOTER */}
          <div className="footer-actions">
            <Button variant="light" onClick={handleClose}>Cancel</Button>
            <Button className="btn-orange">Add Pipeline</Button>
          </div>

        </Modal.Body>
      </Modal>

      {/* CHILD MODALS */}
      <EditStage show={showAddStage} handleClose={() => setShowAddStage(false)} />
      <EditLeadStage show={showEditStage} handleClose={() => setShowEditStage(false)} />
      <DeleteLeadStage show={showDeleteStage} handleClose={() => setShowDeleteStage(false)} />

      <style>{`
        .stage-item {
          display:flex;
          justify-content:space-between;
          align-items:center;
          border:1px solid #eee;
          padding:10px;
          border-radius:6px;
          margin-top:8px;
          background:#fafafa;
        }

        .icons {
          display:flex;
          gap:10px;
          cursor:pointer;
        }

        .add-new {
          color:#ff6b2c;
          cursor:pointer;
          font-size:13px;
        }

        .btn-orange {
          background:#ff6b2c;
          border:none;
          color:white;
        }

        .footer-actions {
          display:flex;
          justify-content:flex-end;
          gap:10px;
          margin-top:20px;
        }
      `}</style>
    </>
  );
};

export default EditPipelineModal;